var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgBgFaq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 632,
    viewBox: "0 0 1440 632",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3385_187267",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 632
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 632,
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3385_187267)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3385_187267",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -193,
    y: -604,
    width: 1900,
    height: 1600
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -193,
    y: -604,
    width: 1900,
    height: 1599.63,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3385_187267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M627.851 330.395C897.78 212.232 1159.76 523.871 1382.17 330.395C1638.28 107.61 1382.17 -539.636 1382.17 -539.636L102.068 -560C102.068 -560 -449.335 1105.38 102.068 926.566C397.13 830.882 343.665 454.798 627.851 330.395Z",
    fill: "#41289E",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.851 330.395C897.78 212.232 1159.76 523.871 1382.17 330.395C1638.28 107.61 1382.17 -539.636 1382.17 -539.636L102.068 -560C102.068 -560 -449.335 1105.38 102.068 926.566C397.13 830.882 343.665 454.798 627.851 330.395Z",
    fill: "url(#paint0_linear_3385_187267)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3385_187267",
    x1: 1496,
    y1: 190,
    x2: -143,
    y2: 190,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BCBBF",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6BE5",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBgFaq);
export default __webpack_public_path__ + "static/media/img_bg_faq.4403320d7512e79a87a576a34872c1ff.svg";
export { ForwardRef as ReactComponent };